<app-progress-spinner *ngIf="spinner"></app-progress-spinner>

<div class="app-context">
  <app-hlavicka-dokumentu
    (jazykZmena)="setVisibleDataByLanguage($event)"
    [jazyk]=kodJazykRadioBox
    [disabled]="typyZaznamovNaStranu.length === 0">
  </app-hlavicka-dokumentu>
</div>

<div>

  <!-- toto tu je cisto len kvoli skoku na zaciatok formulara po presunuti na dalsiu stranku -->
  <div id="zacFormularTarget"></div>

  <dl class="row mb-2 ms-2 mt-2">

    <dt class="col-sm-3 d-none d-sm-block text-end" i18n>Názov vysokej školy</dt>
    <dd *ngIf="data" class="col-sm-9 d-none d-sm-block">{{data.univerzitaPopis}}</dd>
    <!-- <dd class="col-sm-8 d-none d-sm-block">Univerzita Pavla Jozefa Šafárika v Košiciach</dd> -->

    <dt class="col-sm-3 d-none d-sm-block text-end" i18n>Sídlo vysokej školy</dt>
    <dd *ngIf="data" class="col-sm-9 d-none d-sm-block">{{data.univerzitaAdresa}}</dd>
    <!-- <dd class="col-sm-8 d-none d-sm-block">Šrobárova 2, 041 80 Košice</dd> -->

    <ng-template [ngIf]="idDruhDokumentu !== DOKUMENT_TEXT_OSOBY">

      <dt class="col-sm-3 d-none d-sm-block text-end" i18n>Názov fakulty</dt>
      <dd *ngIf="data" class="col-sm-9 d-none d-sm-block">{{data.fakultaPopis}}</dd>
      <!-- <dd class="col-sm-8 d-none d-sm-block">Prírodovedecká fakulta</dd> -->

      <dt class="col-sm-3 d-none d-sm-block text-end" i18n>Sídlo fakulty</dt>
      <dd *ngIf="data" class="col-sm-9 d-none d-sm-block">{{data.fakultaAdresa}}</dd>
      <!-- <dd class="col-sm-8 d-none d-sm-block">Šrobárova 2, 041 54 Košice</dd> -->

    </ng-template>

  </dl>

</div>


<div class="margin-container">

  <!-- button pre kopirovanie formulara zo stud. programu alebo podprogramu-->
  <div *ngIf="idDruhDokumentu === DOKUMENT_TEXT_STUDIJNEHO_PROGRAMU_PODPROGRAMU_HAIK"
      class="d-flex justify-content-between">

    <div>
      <!-- <button *ngIf="idPodprogram === -1" -->
      <button
        mat-mini-fab color="primary" class="m-2"
        type="button"
        (click)="openStudijneProgramyPodprogramyDialog()"
        [matTooltip]="getKopirovaciButtonTooltip()">
        <mat-icon>content_copy</mat-icon>
        <!-- <mat-icon>library_add</mat-icon> -->
      </button>
    </div>

    <div>
      <button
        mat-mini-fab color="primary" class="m-2"
        type="button"
        (click)="vymazatFormular()"
        [matTooltip]="getVymazatFormularTooltip()">
        <mat-icon>delete</mat-icon>
        <!-- <mat-icon>library_add</mat-icon> -->
      </button>
    </div>

  </div>




  <form [formGroup]="formularFormGroup" (ngSubmit)="onSubmit()"
    (keydown.enter)="$event.preventDefault()">

    <div class="mt-3 mat-typography">

      <!-- karticky reprezentujuce jednotlive strany -->
      <!-- <mat-card class="mt-5 pt-4" *ngFor="let strana of poleStran;"> -->
      <mat-card class="mt-1 pt-3 pb-4">

        <div *ngFor="let typ of typyZaznamovNaStranu">

          <div [ngClass]="{'d-none': !typ.polozkaJePlatna,
            'd-block': typ.polozkaJePlatna}">

            <!-- karticky pre jednotlive typy zaznamov textu (SCSTTypZaznamuTextu) -->

            <mat-card class="mt-2 mx-3 pt-2 pb-1 px-3"
              *ngIf="(!typ.idSkupina || typ.idSkupina === 0)
                    || (typ.idDruhZaznamuTextu !== POLOZKA && !somPolozkaVnutriSkupiny(typ))"

              [ngClass]="{'pb-2': typ.idTypObjektu === TEXTAREA}">

              <div *ngIf="(!typ.idSkupina || typ.idSkupina === 0);else skupinovePolozky;">

                <div [ngSwitch]="typ.idDruhZaznamuTextu">

                  <!-- 1 - Nadpis -->
                  <app-nadpis-blok-sekcia-druh *ngSwitchCase="NADPIS"
                    [idDruhZaznamuTextu]="NADPIS"
                    [kodJazyk]="kodJazykRadioBox" [typZaznamuTextu]="typ"
                    [formularFormGroup]="formularFormGroup"
                    [mapaJazykovAMapIdSkupinACastiSkupin]="mapaJazykovAMapIdSkupinACastiSkupin">
                  </app-nadpis-blok-sekcia-druh>
                  <!-- 2 - Blok -->
                  <app-nadpis-blok-sekcia-druh *ngSwitchCase="BLOK"
                    [idDruhZaznamuTextu]="BLOK"
                    [kodJazyk]="kodJazykRadioBox" [typZaznamuTextu]="typ"
                    [formularFormGroup]="formularFormGroup"
                    [mapaJazykovAMapIdSkupinACastiSkupin]="mapaJazykovAMapIdSkupinACastiSkupin">
                  </app-nadpis-blok-sekcia-druh>
                  <!-- 3 - Sekcia -->
                  <app-nadpis-blok-sekcia-druh *ngSwitchCase="SEKCIA"
                    [idDruhZaznamuTextu]="SEKCIA"
                    [kodJazyk]="kodJazykRadioBox" [typZaznamuTextu]="typ"
                    [formularFormGroup]="formularFormGroup"
                    [mapaJazykovAMapIdSkupinACastiSkupin]="mapaJazykovAMapIdSkupinACastiSkupin">
                  </app-nadpis-blok-sekcia-druh>
                  <!-- 4 - Polozka -->
                  <div *ngSwitchCase="POLOZKA" style="padding-top: 0.4rem;">

                    <!-- staci nam upozornenie zabezpecit pre opakovane polozky, pretoze pre neopakovane a skupinove
                       su vyriesene na inom mieste (neopakovane priamo v komponentoch, skupinove nizsie v kode) -->
                    <div *ngIf="typ.uroven === 2 && !appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty
                          && (typ.opakovanie === 'A' || this.appStateService.jeOpakovaniePodprogramu(typ))"
                        class="text-warning" i18n>
                        *položka je editovateľná len z úrovne fakulty
                    </div>

                    <div>

                      <!-- atribut "variant" pri opakovani riesime v samostatnych komponentoch -->
                      <div *ngIf="!(typ.opakovanie === 'A')" class="d-flex justify-content-end">

                        <app-stupen-typ-studia *ngIf="typ.vazba === VAZBA_STUPEN_TYP_STUDIA"
                          [idTyp]="typ.id">
                        </app-stupen-typ-studia>

                      </div>

                      <div class="mt-2" [ngSwitch]="typ.idTypObjektu">

                        <app-input-typ *ngSwitchCase="INPUT"
                          [typZaznamuTextu]="typ" [kodJazykIN]="kodJazykRadioBox"
                          [formularFormGroup]="formularFormGroup">
                        </app-input-typ>

                        <app-input-typ *ngSwitchCase="NON_NEGATIVE_INTEGER"
                          [typZaznamuTextu]="typ" [kodJazykIN]="kodJazykRadioBox"
                          [formularFormGroup]="formularFormGroup">
                        </app-input-typ>

                        <app-textarea-typ *ngSwitchCase="TEXTAREA"
                          [typZaznamuTextu]="typ" [kodJazykIN]="kodJazykRadioBox"
                          [formularFormGroup]="formularFormGroup">
                        </app-textarea-typ>

                        <!-- 3 - select (combobox) -->
                        <app-select-typ *ngSwitchCase="SELECT"
                          [typZaznamuTextu]="typ" [kodJazykIN]="kodJazykRadioBox"
                          [formularFormGroup]="formularFormGroup">
                        </app-select-typ>

                        <!-- 4 - autocomplete -->
                        <ng-container *ngSwitchCase="AUTOCOMPLETE">

                          <ng-container *ngIf="typ.opakovanie === 'A' || appStateService.jeOpakovaniePodprogramu(typ);else neopakovanyAutocomplete">

                            <div *ngIf="kodJazykRadioBox.includes(jazyk1)">
                              <ng-container *ngFor="let controlFromArray of mapaIdTypovAPoliAutocompletov.get(typ.id)?.controls;
                                  let i = index; last as last;">
                                <app-autocomplete-typ
                                  [typZaznamuTextu]="typ" [kodJazykIN]="jazyk1"
                                  [kodJazykRadioBox]="kodJazykRadioBox"
                                  [formularFormGroup]="formularFormGroup"
                                  [indexPolozkyVoFormulari]="i"
                                  [somPoslednaOpakovanaPolozka]="last">
                                </app-autocomplete-typ>
                              </ng-container>
                            </div>
                            <div *ngIf="kodJazykRadioBox.includes(jazyk2)">
                              <ng-container *ngFor="let controlFromArray of mapaIdTypovAPoliAutocompletovJazyk2.get(typ.id)?.controls;
                                  let i = index; last as last">
                                <app-autocomplete-typ
                                  [typZaznamuTextu]="typ" [kodJazykIN]="jazyk2"
                                  [kodJazykRadioBox]="kodJazykRadioBox"
                                  [formularFormGroup]="formularFormGroup"
                                  [indexPolozkyVoFormulari]="i"
                                  [somPoslednaOpakovanaPolozka]="last">
                                </app-autocomplete-typ>
                              </ng-container>
                            </div>
                            <div *ngIf="kodJazykRadioBox.includes(jazyk3)">
                              <ng-container *ngFor="let controlFromArray of mapaIdTypovAPoliAutocompletovJazyk3.get(typ.id)?.controls;
                                  let i = index; last as last">
                                <app-autocomplete-typ
                                  [typZaznamuTextu]="typ" [kodJazykIN]="jazyk3"
                                  [kodJazykRadioBox]="kodJazykRadioBox"
                                  [formularFormGroup]="formularFormGroup"
                                  [indexPolozkyVoFormulari]="i"
                                  [somPoslednaOpakovanaPolozka]="last">
                                </app-autocomplete-typ>
                              </ng-container>
                            </div>
                          </ng-container>

                          <ng-template #neopakovanyAutocomplete>
                            <app-autocomplete-typ
                              [typZaznamuTextu]="typ" [kodJazykIN]="kodJazykRadioBox"
                              [formularFormGroup]="formularFormGroup">
                            </app-autocomplete-typ>
                          </ng-template>
                        </ng-container>

                        <!-- 5 - date -->
                        <app-date-typ *ngSwitchCase="DATE"
                          [typZaznamuTextu]="typ" [kodJazykIN]="kodJazykRadioBox"
                          [formularFormGroup]="formularFormGroup"
                          (datumZmenenyManualne)="oznacAkoManualneUpravene()">
                        </app-date-typ>

                      </div>

                      <div *ngSwitchDefault></div>

                    </div>

                  </div>
                  <div *ngSwitchDefault></div>
                </div>

              </div>


              <!-- SKUPINOVE OPAKOVANIE -->
              <ng-template #skupinovePolozky>

                <div *ngIf="typ.idDruhZaznamuTextu !== POLOZKA">

                  <!-- 4 - Polozka - pri skupinovom opakovani dotahujeme vzdy -->
                  <div *ngIf="kodJazykRadioBox.includes(jazyk1)" style="padding-top: 0.4rem;">

                    <!-- SK VERZIA  -->
                    <div [ngSwitch]="typ.idDruhZaznamuTextu">

                      <!-- 1 - Nadpis -->
                      <app-nadpis-blok-sekcia-druh *ngSwitchCase="NADPIS"
                        [idDruhZaznamuTextu]="NADPIS"
                        [kodJazyk]="jazyk1" [kodJazykRadiobox]="kodJazykRadioBox"
                        [typZaznamuTextu]="typ"
                        [formularFormGroup]="formularFormGroup"
                        [pocetTypovVSkupine]="mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length ?? 0"
                        [mapaJazykovAMapIdSkupinACastiSkupin]="mapaJazykovAMapIdSkupinACastiSkupin"
                        (pridatSkupinoveOpakovanie)="pridatSkupinoveOpakovanie(typ.idSkupina,
                                    mapaIdSkupinAMaxPoctovOpakovani.get(typ.idSkupina) ?? 0,
                                    jazyk1, true, [], $event)">
                      </app-nadpis-blok-sekcia-druh>
                      <!-- 2 - Blok -->
                      <app-nadpis-blok-sekcia-druh *ngSwitchCase="BLOK"
                        [idDruhZaznamuTextu]="BLOK"
                        [kodJazyk]="jazyk1" [kodJazykRadiobox]="kodJazykRadioBox"
                        [typZaznamuTextu]="typ"
                        [formularFormGroup]="formularFormGroup"
                        [pocetTypovVSkupine]="mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length ?? 0"
                        [mapaJazykovAMapIdSkupinACastiSkupin]="mapaJazykovAMapIdSkupinACastiSkupin"
                        (pridatSkupinoveOpakovanie)="pridatSkupinoveOpakovanie(typ.idSkupina,
                                    mapaIdSkupinAMaxPoctovOpakovani.get(typ.idSkupina) ?? 0,
                                    jazyk1, true, [], $event)">
                      </app-nadpis-blok-sekcia-druh>
                      <!-- 3 - Sekcia -->
                      <app-nadpis-blok-sekcia-druh *ngSwitchCase="SEKCIA"
                        [idDruhZaznamuTextu]="SEKCIA"
                        [kodJazyk]="jazyk1" [kodJazykRadiobox]="kodJazykRadioBox"
                        [typZaznamuTextu]="typ"
                        [formularFormGroup]="formularFormGroup"
                        [pocetTypovVSkupine]="mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length ?? 0"
                        [mapaJazykovAMapIdSkupinACastiSkupin]="mapaJazykovAMapIdSkupinACastiSkupin"
                        (pridatSkupinoveOpakovanie)="pridatSkupinoveOpakovanie(typ.idSkupina,
                                    mapaIdSkupinAMaxPoctovOpakovani.get(typ.idSkupina) ?? 0,
                                    jazyk1, true, [], $event)">
                      </app-nadpis-blok-sekcia-druh>

                    </div>


                    <!-- {{mapaIdSkupinATypovZaznamov.get(typ.idSkupina).length}} -->
                    <div>

                      <div *ngFor="let skupinaCislo of mapaIdSkupinACastiSkupin.get(typ.idSkupina) || [];
                              let ind = index; last as last">

                        <!-- SWAPOVACI BUTTON -->
                        <div class="d-flex">
                          <button *ngIf="ind > 0 && ind < (mapaIdSkupinACastiSkupin.get(typ.idSkupina)?.length || 0)"
                            class="ms-auto mt-2"
                            mat-icon-button
                            type="button"
                            (click)="presunSkupinovePolozky(typ, ind, jazyk1)"
                            [matTooltip]="getVymenitSkupinyPoloziekTooltip()"
                            aria-label="Vymeniť skupiny položiek">
                            <mat-icon>swap_vert</mat-icon>
                          </button>
                        </div>

                        <mat-card class="mt-1 pt-3 pb-1 px-3"
                            [ngClass]="{'mb-3': typ.maxPocet === 1}">

                          <div *ngIf="typ.uroven === 2 && !appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty"
                              class="text-warning pb-2" i18n>
                              *položka je editovateľná len z úrovne fakulty
                          </div>

                          <div class="d-flex justify-content-between">

                            <div class="h5 mb-1">
                              <span *ngIf="typ.maxPocet > 1">{{skupinaCislo}}.</span>
                            </div>
                            <app-stupen-typ-studia *ngIf="typ.vazba === VAZBA_STUPEN_TYP_STUDIA"
                              [idSkupina]="typ.idSkupina" [poradieOpakovanejPolozky]="skupinaCislo"
                              [castSkupiny]="skupinaCislo" [jazyk]="jazyk1">
                            </app-stupen-typ-studia>

                          </div>

                          <div *ngFor="let typZaznamu of mapaIdSkupinAMapCastiATypovZaznamov.get(typ.idSkupina)?.get(skupinaCislo);
                            let i = index;">

                            <div *ngIf="typZaznamu.uroven === 2 && !appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty"
                                class="text-warning pb-2" i18n>
                                *položka je editovateľná len z úrovne fakulty
                            </div>

                            <div class="mt-1" [ngSwitch]="typZaznamu.idTypObjektu">

                              <app-input-typ *ngSwitchCase="INPUT"
                                [indexPolozkyVoFormulari]="i + ind * (mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length ?? 0)"
                                [typZaznamuTextu]="typZaznamu" [kodJazykIN]="jazyk1"
                                [formularFormGroup]="formularFormGroup">
                              </app-input-typ>

                              <app-input-typ *ngSwitchCase="NON_NEGATIVE_INTEGER"
                                [indexPolozkyVoFormulari]="i + ind * (mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length ?? 0)"
                                [typZaznamuTextu]="typZaznamu" [kodJazykIN]="jazyk1"
                                [formularFormGroup]="formularFormGroup">
                              </app-input-typ>

                              <app-textarea-typ *ngSwitchCase="TEXTAREA"
                                [indexPolozkyVoFormulari]="i + ind * (mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length ?? 0)"
                                [typZaznamuTextu]="typZaznamu" [kodJazykIN]="jazyk1"
                                [formularFormGroup]="formularFormGroup">
                              </app-textarea-typ>

                              <!-- 3 - select (combobox) -->
                              <app-select-typ *ngSwitchCase="SELECT"
                                [typZaznamuTextu]="typZaznamu" [kodJazykIN]="jazyk1"
                                [indexPolozkyVoFormulari]="i + ind * (mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length ?? 0)"
                                [formularFormGroup]="formularFormGroup">
                              </app-select-typ>

                              <!-- 4 - autocomplete -->
                              <app-autocomplete-typ *ngSwitchCase="AUTOCOMPLETE"
                                [typZaznamuTextu]="typZaznamu" [kodJazykIN]="jazyk1"
                                [indexPolozkyVoFormulari]="i + ind * (mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length ?? 0)"
                                [formularFormGroup]="formularFormGroup"
                                (zmenaHodnotyVAutocomplete)="pridatHodnotuDoFormulara($event,
                                  typZaznamu.idSkupina, i, jazyk1)">
                              </app-autocomplete-typ>

                              <!-- 5 - date -->
                              <app-date-typ *ngSwitchCase="DATE"
                                [typZaznamuTextu]="typZaznamu" [kodJazykIN]="jazyk1"
                                [indexPolozkyVoFormulari]="i + ind * (mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length ?? 0)"
                                [formularFormGroup]="formularFormGroup"
                                (datumZmenenyManualne)="oznacAkoManualneUpravene()">
                              </app-date-typ>

                              <div *ngSwitchDefault>
                                <!-- Nadpis, Blok, Sekcia -->
                                <app-nadpis-blok-sekcia-druh
                                  [idDruhZaznamuTextu]="typZaznamu.idDruhZaznamuTextu"
                                  [kodJazyk]="kodJazykRadioBox" [typZaznamuTextu]="typZaznamu"
                                  [mapaJazykovAMapIdSkupinACastiSkupin]="mapaJazykovAMapIdSkupinACastiSkupin"
                                  [formularFormGroup]="formularFormGroup">
                                </app-nadpis-blok-sekcia-druh>
                              </div>

                            </div>

                          </div>

                        </mat-card>

                        <div *ngIf="last && typ.maxPocet > 1"
                            class="mt-3 mb-2 d-flex justify-content-center">
                          <button mat-mini-fab color="primary" type="button"
                            (click)="pridatSkupinoveOpakovanie(typ.idSkupina,
                                mapaIdSkupinAMaxPoctovOpakovani.get(typ.idSkupina) ?? 0,
                                jazyk1, true, [], $event)"
                            [matTooltip]="getPridatPolozkyVSkupineTooltip(typ.maxPocet)"
                            [disabled]="(typ.uroven === 2 || vsetkyTypyVSkupineSuUrovne2(typ.idSkupina, skupinaCislo, jazyk1)) && !appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty">
                            <mat-icon>add</mat-icon>
                          </button>
                        </div>

                      </div>

                    </div>

                  </div>

                  <!-- jazyk 2 VERZIA -->
                  <div *ngIf="kodJazykRadioBox.includes(jazyk2)" style="padding-top: 0.4rem;">

                    <div [ngSwitch]="typ.idDruhZaznamuTextu">

                      <!-- 1 - Nadpis -->
                      <app-nadpis-blok-sekcia-druh *ngSwitchCase="NADPIS"
                        [idDruhZaznamuTextu]="NADPIS"
                        [kodJazyk]="jazyk2" [typZaznamuTextu]="typ"
                        [formularFormGroup]="formularFormGroup"
                        [pocetTypovVSkupine]="mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length ?? 0"
                        [mapaJazykovAMapIdSkupinACastiSkupin]="mapaJazykovAMapIdSkupinACastiSkupin"
                        (pridatSkupinoveOpakovanie)="pridatSkupinoveOpakovanie(typ.idSkupina,
                                    mapaIdSkupinAMaxPoctovOpakovani.get(typ.idSkupina) ?? 0,
                                    jazyk2, true, [], $event)">
                      </app-nadpis-blok-sekcia-druh>
                      <!-- 2 - Blok -->
                      <app-nadpis-blok-sekcia-druh *ngSwitchCase="BLOK"
                        [idDruhZaznamuTextu]="BLOK"
                        [kodJazyk]="jazyk2" [typZaznamuTextu]="typ"
                        [formularFormGroup]="formularFormGroup"
                        [pocetTypovVSkupine]="mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length ?? 0"
                        [mapaJazykovAMapIdSkupinACastiSkupin]="mapaJazykovAMapIdSkupinACastiSkupin"
                        (pridatSkupinoveOpakovanie)="pridatSkupinoveOpakovanie(typ.idSkupina,
                                    mapaIdSkupinAMaxPoctovOpakovani.get(typ.idSkupina) ?? 0,
                                    jazyk2, true, [], $event)">
                      </app-nadpis-blok-sekcia-druh>
                      <!-- 3 - Sekcia -->
                      <app-nadpis-blok-sekcia-druh *ngSwitchCase="SEKCIA"
                        [idDruhZaznamuTextu]="SEKCIA"
                        [kodJazyk]="jazyk2" [typZaznamuTextu]="typ"
                        [formularFormGroup]="formularFormGroup"
                        [pocetTypovVSkupine]="mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length ?? 0"
                        [mapaJazykovAMapIdSkupinACastiSkupin]="mapaJazykovAMapIdSkupinACastiSkupin"
                        (pridatSkupinoveOpakovanie)="pridatSkupinoveOpakovanie(typ.idSkupina,
                                    mapaIdSkupinAMaxPoctovOpakovani.get(typ.idSkupina) ?? 0,
                                    jazyk2, true, [], $event)">
                      </app-nadpis-blok-sekcia-druh>

                    </div>

                    <!-- {{mapaIdSkupinATypovZaznamovEN.get(typ.idSkupina).length}} -->
                    <div *ngFor="let skupinaCislo of mapaIdSkupinACastiSkupinJazyk2.get(typ.idSkupina);
                            let ind = index; last as last">

                      <!-- SWAPOVACI BUTTON -->
                      <div class="d-flex">
                        <button *ngIf="ind > 0 && ind < (mapaIdSkupinACastiSkupin.get(typ.idSkupina)?.length ?? 0)"
                          class="ms-auto mt-2"
                          mat-icon-button
                          type="button"
                          (click)="presunSkupinovePolozky(typ, ind, jazyk2)"
                          [matTooltip]="getVymenitSkupinyPoloziekTooltip()"
                          aria-label="Vymeniť skupiny položiek">
                          <mat-icon>swap_vert</mat-icon>
                        </button>
                      </div>

                      <mat-card class="mt-1 pt-3 pb-1 px-3"
                        [ngClass]="{'mb-3': typ.maxPocet === 1}">

                        <div *ngIf="typ.uroven === 2 && !appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty"
                            class="text-warning pb-2" i18n>
                            *položka je editovateľná len z úrovne fakulty
                        </div>

                        <div class="d-flex justify-content-between">

                          <div class="h5 mb-1">
                            <span *ngIf="typ.maxPocet > 1">{{skupinaCislo}}.</span>
                          </div>
                          <app-stupen-typ-studia *ngIf="typ.vazba === VAZBA_STUPEN_TYP_STUDIA"
                            [idSkupina]="typ.idSkupina" [poradieOpakovanejPolozky]="skupinaCislo" [castSkupiny]="skupinaCislo"
                            [disabled]="kodJazykRadioBox !== jazyk2" [jazyk]="jazyk2">
                          </app-stupen-typ-studia>

                        </div>

                        <div *ngFor="let typZaznamu of mapaIdSkupinAMapCastiATypovZaznamovJazyk2.get(typ.idSkupina)?.get(skupinaCislo);
                          let i = index;">

                          <div *ngIf="typZaznamu.uroven === 2 && !appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty"
                              class="text-warning pb-2" i18n>
                              *položka je editovateľná len z úrovne fakulty
                          </div>

                          <div class="mt-1" [ngSwitch]="typZaznamu.idTypObjektu">

                            <app-input-typ *ngSwitchCase="INPUT"
                              [indexPolozkyVoFormulari]="i + (ind * (mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length ?? 0))"
                              [typZaznamuTextu]="typZaznamu" [kodJazykIN]="jazyk2"
                              [formularFormGroup]="formularFormGroup">
                            </app-input-typ>

                            <app-input-typ *ngSwitchCase="NON_NEGATIVE_INTEGER"
                              [indexPolozkyVoFormulari]="i + (ind * (mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length ?? 0))"
                              [typZaznamuTextu]="typZaznamu" [kodJazykIN]="jazyk2"
                              [formularFormGroup]="formularFormGroup">
                            </app-input-typ>

                            <app-textarea-typ *ngSwitchCase="TEXTAREA"
                              [indexPolozkyVoFormulari]="i + (ind * (mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length ?? 0))"
                              [typZaznamuTextu]="typZaznamu" [kodJazykIN]="jazyk2"
                              [formularFormGroup]="formularFormGroup">
                            </app-textarea-typ>

                            <!-- 3 - select (combobox) -->
                            <app-select-typ *ngSwitchCase="SELECT"
                              [typZaznamuTextu]="typZaznamu" [kodJazykIN]="jazyk2"
                              [indexPolozkyVoFormulari]="i + (ind * (mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length ?? 0))"
                              [formularFormGroup]="formularFormGroup">
                            </app-select-typ>

                            <!-- 4 - autocomplete -->
                            <app-autocomplete-typ *ngSwitchCase="AUTOCOMPLETE"
                              [typZaznamuTextu]="typZaznamu" [kodJazykIN]="jazyk2"
                              [indexPolozkyVoFormulari]="i + (ind * (mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length ?? 0))"
                              [formularFormGroup]="formularFormGroup"
                              (zmenaHodnotyVAutocomplete)="pridatHodnotuDoFormulara($event,
                                typZaznamu.idSkupina, i, jazyk2)">
                            </app-autocomplete-typ>

                            <!-- 5 - date -->
                            <app-date-typ *ngSwitchCase="DATE"
                              [typZaznamuTextu]="typZaznamu" [kodJazykIN]="jazyk2"
                              [indexPolozkyVoFormulari]="i + (ind * (mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length ?? 0))"
                              [formularFormGroup]="formularFormGroup"
                              (datumZmenenyManualne)="oznacAkoManualneUpravene()">
                            </app-date-typ>

                            <div *ngSwitchDefault>
                              <!-- Nadpis, Blok, Sekcia -->
                              <app-nadpis-blok-sekcia-druh
                                [idDruhZaznamuTextu]="typZaznamu.idDruhZaznamuTextu"
                                [kodJazyk]="kodJazykRadioBox" [typZaznamuTextu]="typZaznamu"
                                [pocetTypovVSkupine]="mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length ?? 0"
                                [mapaJazykovAMapIdSkupinACastiSkupin]="mapaJazykovAMapIdSkupinACastiSkupin"
                                [formularFormGroup]="formularFormGroup">
                              </app-nadpis-blok-sekcia-druh>
                            </div>

                          </div>

                        </div>

                      </mat-card>

                      <div *ngIf="last && typ.maxPocet > 1"
                          class="mt-3 mb-3 d-flex justify-content-center">
                        <button mat-mini-fab color="primary" type="button"
                          (click)="pridatSkupinoveOpakovanie(typ.idSkupina,
                          	mapaIdSkupinAMaxPoctovOpakovani.get(typ.idSkupina) ?? 0,
														jazyk2, true, [], $event)"
                          [matTooltip]="getPridatPolozkyVSkupineTooltip(typ.maxPocet)"
                          [disabled]="(typ.uroven === 2 || vsetkyTypyVSkupineSuUrovne2(typ.idSkupina, skupinaCislo, jazyk2)) && !appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty">
                          <mat-icon>add</mat-icon>
                        </button>
                      </div>

                      <!-- <div *ngIf="ind < typ.maxPocet">

                      </div> -->

                    </div>

                  </div>


                  <!-- jazyk 3 VERZIA -->
                  <div *ngIf="kodJazykRadioBox.includes(jazyk3)" style="padding-top: 0.4rem;">

                    <div [ngSwitch]="typ.idDruhZaznamuTextu">

                      <!-- 1 - Nadpis -->
                      <app-nadpis-blok-sekcia-druh *ngSwitchCase="NADPIS"
                        [idDruhZaznamuTextu]="NADPIS"
                        [kodJazyk]="jazyk3" [typZaznamuTextu]="typ"
                        [formularFormGroup]="formularFormGroup"
                        [pocetTypovVSkupine]="mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length ?? 0"
                        [mapaJazykovAMapIdSkupinACastiSkupin]="mapaJazykovAMapIdSkupinACastiSkupin"
                        (pridatSkupinoveOpakovanie)="pridatSkupinoveOpakovanie(typ.idSkupina,
                                    mapaIdSkupinAMaxPoctovOpakovani.get(typ.idSkupina) ?? 0,
                                    jazyk3, true, [], $event)">
                      </app-nadpis-blok-sekcia-druh>
                      <!-- 2 - Blok -->
                      <app-nadpis-blok-sekcia-druh *ngSwitchCase="BLOK"
                        [idDruhZaznamuTextu]="BLOK"
                        [kodJazyk]="jazyk3" [typZaznamuTextu]="typ"
                        [formularFormGroup]="formularFormGroup"
                        [pocetTypovVSkupine]="mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length ?? 0"
                        [mapaJazykovAMapIdSkupinACastiSkupin]="mapaJazykovAMapIdSkupinACastiSkupin"
                        (pridatSkupinoveOpakovanie)="pridatSkupinoveOpakovanie(typ.idSkupina,
                                    mapaIdSkupinAMaxPoctovOpakovani.get(typ.idSkupina) ?? 0,
                                    jazyk3, true, [], $event)">
                      </app-nadpis-blok-sekcia-druh>
                      <!-- 3 - Sekcia -->
                      <app-nadpis-blok-sekcia-druh *ngSwitchCase="SEKCIA"
                        [idDruhZaznamuTextu]="SEKCIA"
                        [kodJazyk]="jazyk3" [typZaznamuTextu]="typ"
                        [formularFormGroup]="formularFormGroup"
                        [pocetTypovVSkupine]="mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length ?? 0"
                        [mapaJazykovAMapIdSkupinACastiSkupin]="mapaJazykovAMapIdSkupinACastiSkupin"
                        (pridatSkupinoveOpakovanie)="pridatSkupinoveOpakovanie(typ.idSkupina,
                                    mapaIdSkupinAMaxPoctovOpakovani.get(typ.idSkupina) ?? 0,
                                    jazyk3, true, [], $event)">
                      </app-nadpis-blok-sekcia-druh>

                    </div>


                    <!-- {{mapaIdSkupinATypovZaznamovEN.get(typ.idSkupina).length}} -->
                    <div *ngFor="let skupinaCislo of mapaIdSkupinACastiSkupinJazyk3.get(typ.idSkupina) ?? [];
                            let ind = index; last as last">

                      <!-- SWAPOVACI BUTTON -->
                      <div class="d-flex">
                        <button *ngIf="ind > 0 && ind < (mapaIdSkupinACastiSkupin.get(typ.idSkupina)?.length || 0)"
                          class="ms-auto mt-2"
                          mat-icon-button
                          type="button"
                          (click)="presunSkupinovePolozky(typ, ind, jazyk3)"
                          [matTooltip]="getVymenitSkupinyPoloziekTooltip()"
                          aria-label="Vymeniť skupiny položiek">
                          <mat-icon>swap_vert</mat-icon>
                        </button>
                      </div>

                      <mat-card class="mt-1 pt-3 pb-1 px-3"
                        [ngClass]="{'mb-3': typ.maxPocet === 1}">

                        <div *ngIf="typ.uroven === 2 && !appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty"
                            class="text-warning pb-2" i18n>
                            *položka je editovateľná len z úrovne fakulty
                        </div>

                        <div class="d-flex justify-content-between">

                          <div class="h5 mb-1">
                            <span *ngIf="typ.maxPocet > 1">{{skupinaCislo}}.</span>
                          </div>
                          <app-stupen-typ-studia *ngIf="typ.vazba === VAZBA_STUPEN_TYP_STUDIA"
                            [idSkupina]="typ.idSkupina" [poradieOpakovanejPolozky]="skupinaCislo"
                            [castSkupiny]="skupinaCislo"
                            [disabled]="kodJazykRadioBox !== jazyk3"
                            [jazyk]="jazyk3">
                          </app-stupen-typ-studia>

                        </div>

                        <div *ngFor="let typZaznamu of mapaIdSkupinAMapCastiATypovZaznamovJazyk3.get(typ.idSkupina)?.get(skupinaCislo) ?? [];
                          let i = index;">

                          <div *ngIf="typZaznamu.uroven === 2 && !appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty"
                              class="text-warning pb-2" i18n>
                              *položka je editovateľná len z úrovne fakulty
                          </div>

                          <div class="mt-1" [ngSwitch]="typZaznamu.idTypObjektu">

                            <app-input-typ *ngSwitchCase="INPUT"
                              [indexPolozkyVoFormulari]="i + (ind * (mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length || 0))"
                              [typZaznamuTextu]="typZaznamu" [kodJazykIN]="jazyk3"
                              [formularFormGroup]="formularFormGroup">
                            </app-input-typ>

                            <app-input-typ *ngSwitchCase="NON_NEGATIVE_INTEGER"
                              [indexPolozkyVoFormulari]="i + (ind * (mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length || 0))"
                              [typZaznamuTextu]="typZaznamu" [kodJazykIN]="jazyk3"
                              [formularFormGroup]="formularFormGroup">
                            </app-input-typ>

                            <app-textarea-typ *ngSwitchCase="TEXTAREA"
                              [indexPolozkyVoFormulari]="i + (ind * (mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length || 0))"
                              [typZaznamuTextu]="typZaznamu" [kodJazykIN]="jazyk3"
                              [formularFormGroup]="formularFormGroup">
                            </app-textarea-typ>

                            <!-- 3 - select (combobox) -->
                            <app-select-typ *ngSwitchCase="SELECT"
                              [typZaznamuTextu]="typZaznamu" [kodJazykIN]="jazyk3"
                              [indexPolozkyVoFormulari]="i + (ind * (mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length || 0))"
                              [formularFormGroup]="formularFormGroup">
                            </app-select-typ>

                            <!-- 4 - autocomplete -->
                            <app-autocomplete-typ *ngSwitchCase="AUTOCOMPLETE"
                              [typZaznamuTextu]="typZaznamu" [kodJazykIN]="jazyk3"
                              [indexPolozkyVoFormulari]="i + (ind * (mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length || 0))"
                              [formularFormGroup]="formularFormGroup"
                              (zmenaHodnotyVAutocomplete)="pridatHodnotuDoFormulara($event,
                                typZaznamu.idSkupina, i, jazyk3)">
                            </app-autocomplete-typ>

                            <!-- 5 - date -->
                            <app-date-typ *ngSwitchCase="DATE"
                              [typZaznamuTextu]="typZaznamu" [kodJazykIN]="jazyk3"
                              [indexPolozkyVoFormulari]="i + (ind * (mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length || 0))"
                              [formularFormGroup]="formularFormGroup"
                              (datumZmenenyManualne)="oznacAkoManualneUpravene()">
                            </app-date-typ>

                            <div *ngSwitchDefault>
                              <!-- Nadpis, Blok, Sekcia -->
                              <app-nadpis-blok-sekcia-druh
                                [idDruhZaznamuTextu]="typZaznamu.idDruhZaznamuTextu"
                                [kodJazyk]="kodJazykRadioBox" [typZaznamuTextu]="typZaznamu"
                                [pocetTypovVSkupine]="mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length ?? 0"
                                [formularFormGroup]="formularFormGroup"
                                [pocetTypovVSkupine]="mapaIdJednoznacnychTypovVSkupine.get(typ.idSkupina)?.length ?? 0"
                                [mapaJazykovAMapIdSkupinACastiSkupin]="mapaJazykovAMapIdSkupinACastiSkupin"
                                (pridatSkupinoveOpakovanie)="pridatSkupinoveOpakovanie(typ.idSkupina,
                                            mapaIdSkupinAMaxPoctovOpakovani.get(typ.idSkupina) ?? 0,
                                            kodJazykRadioBox, true, [], $event)">
                              </app-nadpis-blok-sekcia-druh>
                              <div>kodjazykradiobox : {{kodJazykRadioBox}}</div>
                            </div>

                          </div>

                        </div>

                      </mat-card>

                      <div *ngIf="last && typ.maxPocet > 1"
                          class="mt-3 mb-3 d-flex justify-content-center">
                        <button mat-mini-fab color="primary" type="button"
                          (click)="pridatSkupinoveOpakovanie(typ.idSkupina,
                            mapaIdSkupinAMaxPoctovOpakovani.get(typ.idSkupina) ?? 0,
                            jazyk3, true, [])"
                          [matTooltip]="getPridatPolozkyVSkupineTooltip(typ.maxPocet)"
                          [disabled]="(typ.uroven === 2 || vsetkyTypyVSkupineSuUrovne2(typ.idSkupina, skupinaCislo, jazyk3)) && !appStateService.pouzivatelMozeEditovatPolozkyZUrovneFakulty">
                          <mat-icon>add</mat-icon>
                        </button>
                      </div>

                      <!-- <div *ngIf="ind < typ.maxPocet">

                      </div> -->

                    </div>


                  </div>

                </div>

              </ng-template>

            </mat-card>

          </div>

        </div>

      </mat-card>


      <!-- STRANKOVANIE - NAVIGACNE PRVKY -->
      <div class="d-flex flex-row justify-content-center mt-3">

        <!-- <div class="flex-center d-none d-sm-block"> -->
          <div class="d-flex flex-row flex-center">

            <button mat-flat-button color="primary"
              class="mb-2 me-3" type="button"
              [ngClass]="{'btn-mat': aktualnaStrana !== 1}"
              (click)="prvaStrana()"
              [disabled]="aktualnaStrana === 1 || disablovatNavigacneButtonyKvoliZadaniuStrany"
              [matTooltip]="getPrvaStranaTooltip()" matTooltipPosition="left">
              <mat-icon class="my-1 pb-4 ikonka-posledna-strana">
                first_page
              </mat-icon>
            </button>
<!--
            <button mat-flat-button color="primary" class="mb-2 me-3" type="button"
              [ngClass]="{'btn-mat': aktualnaStrana !== 1}"
              (click)="prvaStrana()" [disabled]="aktualnaStrana === 1
                || disablovatNavigacneButtonyKvoliZadaniuStrany"
              matTooltip="Prvá strana" matTooltipPosition="left">
              <mat-icon class="ps-1"
                style="margin-top: -19px; margin-left: -26px; font-size: 31pt;">
                first_page
              </mat-icon>
            </button>
             -->
            <button mat-flat-button color="primary"
              class="mb-2 me-3" type="button"
              [ngClass]="{'btn-mat': aktualnaStrana >= 2}"
              (click)="vlavo(aktualnaStrana)"
              [disabled]="aktualnaStrana < 2 || disablovatNavigacneButtonyKvoliZadaniuStrany"
              [matTooltip]="getVlavoTooltip()" matTooltipPosition="above">
              <mat-icon class="my-1 pb-4 ikonka-doprava"
                style="margin-top: 2px; margin-left: 3px;">
                arrow_back_ios
              </mat-icon>
            </button>

<!--
            <button mat-flat-button color="primary" class="mb-2 me-3" type="button"
              [ngClass]="{'btn-mat': aktualnaStrana >= 2}"
              (click)="vlavo(aktualnaStrana)" [disabled]="aktualnaStrana < 2
                || disablovatNavigacneButtonyKvoliZadaniuStrany"
              matTooltip="Strana {{aktualnaStrana - 1}}" matTooltipPosition="above">
              <mat-icon class="ps-1" style="margin-top: -1px;">arrow_back_ios</mat-icon>
            </button>
 -->

            <div class="pt-2 strana-text d-flex flex-row">
              <span i18n>Strana</span>
              <input style="width: 1.4rem; height: 1.4rem;
                  padding: 0.1rem 0.1rem 0 0.1rem !important;"
                  [ngStyle]="{'margin-top': aktualnaStrana === 1 ? '-2px' : '-1px'}"
                (keydown.enter)="saveStranaInput($event)"
                class="form-control text-center mx-1"
                type="text"
                name="aktualnaStranaInput"
                id="aktualnaStranaInput"
                formControlName="aktualnaStranaControl"
                autocomplete="disabled"
                [value]="aktualnaStrana">
              /
              <span class="ps-1">{{pocetStran}}</span>
            </div>

            <button mat-flat-button color="primary"
              class="mb-2 ms-3" type="button"
              [ngClass]="{'btn-mat': aktualnaStrana <= (pocetStran-1)}"
              (click)="disablovatNavigacneButtonyKvoliZadaniuStrany ? posunNaStranu(zvolenaStrana, true) : vpravo(aktualnaStrana)"
              [disabled]="aktualnaStrana > (pocetStran-1) && disablujPotvrdzovaciButton"
              [matTooltip]="getTooltipPreNavigacnyButton()" matTooltipPosition="above">
              <mat-icon class="my-1 pb-4 ikonka-doprava"
                style="margin-top: 2px; margin-left: 3px;">
                arrow_forward_ios
              </mat-icon>
            </button>
            <button mat-flat-button color="primary"
              class="mb-2 ms-3" type="button"
              [ngClass]="{'btn-mat': aktualnaStrana !== pocetStran}"
              (click)="poslednaStrana()"
              [disabled]="aktualnaStrana === pocetStran || disablovatNavigacneButtonyKvoliZadaniuStrany"
              [matTooltip]="getPoslednaStranaTooltip()" matTooltipPosition="right">
              <mat-icon class="my-1 pb-4 ikonka-posledna-strana">
                last_page
              </mat-icon>
            </button>
<!--
            ALTERNATIVA
            <button mat-flat-button color="primary"
              class="mb-2 ms-3 pb-3" type="button"
              [ngClass]="{'btn-mat': aktualnaStrana !== pocetStran}"
              (click)="poslednaStrana()"
              [disabled]="aktualnaStrana === pocetStran || disablovatNavigacneButtonyKvoliZadaniuStrany"
              matTooltip="Posledná strana" matTooltipPosition="right">
              <mat-icon class="ps-1 mb-4 pe-5 py-5 me-0"
                style="font-size: 31pt; width: 14%;">
                last_page
              </mat-icon>
            </button>
 -->
          </div>


        <!-- ZOBRAZENIE NA MOBILE - zatial zakazeme, robi to sarapatu -->
        <!-- <div class="flex-center d-block d-sm-none">

          <button class="my-button btn btn-sm mb-2 me-2" type="button"
            (click)="prvaStrana()" [disabled]="aktualnaStrana === 1"
            matTooltip="Prvá strana" matTooltipPosition="left">
            <mat-icon style="margin-left: -2px;">
              first_page
            </mat-icon>
          </button>
          <button class="my-button btn btn-sm mb-2 me-2" type="button"
            (click)="vlavo(aktualnaStrana)" [disabled]="aktualnaStrana < 2"
            matTooltip="Strana {{aktualnaStrana - 1}}" matTooltipPosition="above">
            <mat-icon style="margin-left: -3px;">
              chevron_left
            </mat-icon>
          </button>
          <span class="pt-2 strana-text">Strana {{aktualnaStrana}}/{{pocetStran}}</span>
          <button class="my-button btn btn-sm mb-2 ms-2"  type="button"
            (click)="vpravo(aktualnaStrana)" [disabled]="aktualnaStrana > (pocetStran - 1)"
            matTooltip="Strana {{aktualnaStrana + 1}}" matTooltipPosition="above">
            <mat-icon style="margin-left: -2px;">
              chevron_right
            </mat-icon>
          </button>
          <button class="my-button btn btn-sm mb-2 ms-2"  type="button"
            (click)="poslednaStrana()" [disabled]="aktualnaStrana === pocetStran"
            matTooltip="Posledná strana" matTooltipPosition="right">
            <mat-icon style="margin-left: -2px;">
              last_page
            </mat-icon>
          </button>

        </div> -->


      </div>

    </div>

    <div class="d-flex flex-row justify-content-center mt-4">
      <button [disabled]="typyZaznamovNaStranu.length === 0"
        mat-flat-button color="primary" class="btn-mat"
        [ngClass]="{'py-sm-4 py-lg-3': idPodprogram > 0}"
        type="submit" i18n>
        Priebežne uložiť
      </button>
      <button [disabled]="typyZaznamovNaStranu.length === 0"
        mat-flat-button color="primary"
        class="btn-mat ms-3"
        [ngClass]="{'py-sm-4 py-lg-3': idPodprogram > 0}"
        type="button"
        (click)="generujDokument(false)" i18n>
        Generovať dokument
      </button>
      <button *ngIf="idPodprogram > 0"
        [disabled]="typyZaznamovNaStranu.length === 0"
        mat-flat-button color="primary" class="btn-mat ms-3 py-sm-4 py-lg-3" type="button"
        (click)="generujDokumentStudProgramom()" i18n>
        Generovať dokument študijným programom
      </button>
    </div>


    <!-- buttony z bootstrapu - v pripade, ze mat buttony nebudu dobre fungovat -->
<!--
    <div class="d-flex flex-row justify-content-center mt-4">
      <button [disabled]="typyZaznamovNaStranu.length === 0"
        class="btn btn-ok me-2" type="submit">
        Priebežne uložiť
      </button>
      <button [disabled]="typyZaznamovNaStranu.length === 0"
        class="btn btn-ok ms-2" type="button"
        (click)="generujDokument()">
        Generovať dokument
      </button>
    </div>
 -->


  </form>

  <!-- <div id="koniecFormularaTarget"></div> -->



</div>
